import React from "react";
import Grid from "../../GridCards/Grid";
const Parametros = () => {
  return <Grid />;
};

export default Parametros;
